import { translations } from "../translations";

const statsTemplates = {
    text: (data, { html }) => {
        if (data.hasNoResults) return translations.stats.noResults;
        return translations.stats.countResults(Number(data.nbHits).toLocaleString());
    }
}

export default statsTemplates;
